
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import echarts from "echarts"
    import {rulesApi} from "@/api/rules";  //先引入echarts

    @Component({
        name: "rulesChart",
    })
    export default class Map extends Vue {
        title = "规程规范统计图表";
        loading = false;
        listdata1 = [] as any;  //总量
        listdata2 = [] as any;  //年度分类

        mounted() {
            this.getData();
            this.getData2();
        }
        getData(){
            const myChart = echarts.init(this.$refs.chart1);
            this.loading = true;
            rulesApi.count("").then(r => {
                this.loading = false;
                if (r.data.result == 0) {
                    const rData = r.data.data;
                    const tableData = [
                        {name: "地方", value: rData.local},
                        {name: "国家", value: rData.country},
                    ]
                    this.listdata1 = tableData;
                    myChart.setOption({
                        title: {
                            text: '规程规范总量'
                        },
                        tooltip: {},
                        color:[ '#08a4fa','#FF7A7A','#1869A0','#FF9393'],
                        series: [
                            {
                                name: '总量',
                                type: 'pie',
                                radius: '85%',
                                data: tableData,
                                emphasis: {
                                    itemStyle: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    }
                                }
                            }
                        ]
                    });
                }
            })
        }
        getData2(){
            const myChart = echarts.init(this.$refs.chart2);
            this.loading = true;
            rulesApi.countReleaseYear().then(r => {
                this.loading = false;
                if (r.data.result == 0) {
                    const rData = r.data.data;
                    const chartName = [];
                    const chartData1 = [];
                    const chartData2 = [];
                    for(const r of rData){
                        chartName.push(r.year);
                        chartData1.push(r.countType.local);
                        chartData2.push(r.countType.country);
                    }
                    this.listdata2 = rData;
                    myChart.setOption({
                        title: {
                            text: '年变化量'
                        },
                        tooltip: {},
                        xAxis: {
                            data: chartName
                        },
                        yAxis: {},
                        series: [
                            {
                                name: '地方',
                                type: 'bar',
                                data: chartData1,
                                itemStyle: {
                                    normal: {
                                        color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [{
                                            offset: 0,
                                            color: "#1268f3" // 0% 处的颜色
                                        }, {
                                            offset: 0.6,
                                            color: "#08a4fa" // 60% 处的颜色
                                        }, {
                                            offset: 1,
                                            color: "#01ccfe" // 100% 处的颜色
                                        }], false)
                                    },
                                },
                                label: {
                                    show: true, //开启显示
                                    position: 'top', //在上方显示
                                    textStyle: { //数值样式
                                        color: 'red',
                                        fontSize: 16
                                    }
                                }
                            },
                            {
                                name: '国家',
                                type: 'bar',
                                data: chartData2,
                                itemStyle: {
                                    normal: {
                                        color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [{
                                            offset: 0,
                                            color: "#FF5B5B" // 0% 处的颜色
                                        }, {
                                            offset: 0.6,
                                            color: "#FF7A7A" // 60% 处的颜色
                                        }, {
                                            offset: 1,
                                            color: "#FF9B9B" // 100% 处的颜色
                                        }], false)
                                    },
                                },
                                label: {
                                    show: true, //开启显示
                                    position: 'top', //在上方显示
                                    textStyle: { //数值样式
                                        color: 'red',
                                        fontSize: 16
                                    }
                                }
                            }
                        ]
                    });
                }
            })
        }
    }
